import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {ResetChange} from "./reset-change.enum";

@Injectable()
export class ResetPasswordService {
  private static readonly SEND_LINK_FOR_PASSWORD_CHANGE = environment.apiUrl.concat(environment.sendLinkForPasswordChange);
  resetChange = ResetChange;
  queryParamForResetChange : string = 'reset'

  constructor(private httpClient: MasbitHttpService) {
  }

  sendLinkForPasswordChange(email: string, mode : ResetChange) {
    if (mode == this.resetChange.CHANGE)
      this.queryParamForResetChange = 'change'
    else
      this.queryParamForResetChange = 'reset'
    return this.httpClient.get<{status: number, message: string}>(ResetPasswordService.SEND_LINK_FOR_PASSWORD_CHANGE,
                                                                  new HttpParams().set('email', email).set('reset_change', this.queryParamForResetChange));
  }
}
